import type { HttpClient } from "./types";

export interface EnabledMetricsResponse {
    codes: string[];
}

export interface MetricEventRequest {
    metricCode: string;
    entityId?: string;
    entitySku?: string;
}

export const createMetricService = (httpClient: HttpClient) => ({
    getEnabledMetrics: (): Promise<EnabledMetricsResponse> =>
        httpClient.get<EnabledMetricsResponse>("/metricas/habilitadas"),
    recordEvent: (event: MetricEventRequest): Promise<void> =>
        httpClient.post<void>("/metricas/eventos", event),
});
